module.exports = __webpack_public_path__ + "static/media/img-satisfaction@2x.5319fccc.png";